import { Component, OnInit } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'se-app-doc-iframe',
  templateUrl: './app-doc-iframe.component.html',
  styleUrls: ['./app-doc-iframe.component.scss'],
  standalone: false,
})
export class AppDocIframeComponent implements OnInit {

  public url: SafeResourceUrl

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) { }

  public ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
        `/${params.app}/index.html`
      )
    })
  }
}
